import pic1 from "../assets/1-1.jpg"
import pic2 from "../assets/2-1.jpg"
import pic3 from "../assets/3-1.jpg"

export const ProductData = [
    {
        id: 1,
        productName: "1 Person Tent",
        price: 1200,
        intro: "Searching for an ultralight shelter with greater volume? The 1-person NEMO Hornet OSMO ultralight tent offers enviable living space and comfort without sacrificing its airy weight.",
        productImage: pic1,
    },

    {
        id: 2,
        productName: "2 Persons Tent",
        price: 1500,
        intro: "Dropping over a pound from its famed predecessor, the REI Co-op Half Dome SL 2+ backpacking tent is great for two people who appreciate some extra room, intuitive setup and a-spot-for-it-all storage.",
        productImage: pic2,
    },

    {
        id: 3,
        productName: "3-4 Persons Tent",
        price: 2000,
        intro: "Wawona 6 tent has gone from single- to double-wall construction. Plus, its huge vestibule makes it feel less like a tent, more like a home.",
        productImage: pic3,
    },
]